export const webClientId = '715545645650-clgn8aik6stg5fsnvg4o8q81itfj3dc6.apps.googleusercontent.com'